import React, { memo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { Typography } from '@surveycake/rc';
import { SlateHtml } from 'app/shared/components';
import * as styles from './styles';

function Description() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { descpt } = engine.getSubjectData(id);

  if (!descpt) {
    return null;
  }

  return (
    <Typography
      className={styles.description}
      variant="div"
      color="text.B4"
      gutterBottom
    >
      <SlateHtml html={descpt} />
    </Typography>
  );
}

export default memo(Description);
